import { fetchBasicJsonPostJson, fetchBasicJsonPost, fetchGetJson } from '@/script/common';

export default {
    constant: {
        parentCode: (function () {
            var _locals = {
                salary: null,
                salaryTypeManual: null
            };
            var _haveLocals = {
                salary: false,
                salaryTypeManual: false
            };
            return {
                async salary() {
                    if (!_haveLocals.salary) {
                        await fetchBasicJsonPostJson(
                            '/Nosology/GetSalaryParentCode'
                        ).then(resp => {
                            _locals.salary = resp;
                            _haveLocals.salary = true;
                        });
                    }
                    return _locals.salary;
                }
            };
        })()
    },
    getData: (page, itemsPerPage, filter, signal) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        parameters.search = filter.search || null;
        parameters.kod = filter.kod || null;
        parameters.parent_code =
            filter.parent_code && /^\d+$/.test(filter.parent_code)
                ? +filter.parent_code
                : null;
        parameters.prevent_price_check = filter.prevent_price_check || false;
        parameters.prevent_name_dot_check =
            filter.prevent_name_dot_check || false;
        parameters.type = filter.type;
        if (filter.type_any_starts_with) {
            parameters.type_any_starts_with = filter.type_any_starts_with.split(',');
        }
        parameters.person_salary = filter.filter_person_salary;
        if (filter.groupId && (!filter.groupIds || !filter.groupIds.length)) {
            parameters.groupIds = filter.groupId ? [filter.groupId] : null;
        } else if (filter.groupIds && filter.groupIds.length) {
            parameters.groupIds = filter.groupIds;
        }
        return fetchBasicJsonPostJson(
            '/Nosology/GetDataTableData',
            {
                data: parameters,
                signal: signal
            },
            { useBlock: !signal }
        );
    },
    add: item => {
        return fetchBasicJsonPost('/Nosology/Add', {
            data: item
        });
    },
    edit: item => {
        return fetchBasicJsonPost('/Nosology/Edit', {
            data: item
        });
    },
    setNames: item => {
        return fetchBasicJsonPost('/Nosology/SetNames', {
            data: item
        })
    },
    cultureInfo: () => {
        return fetchGetJson('/Culture/GetList')
    },
    getNames: item => {
        return fetchBasicJsonPostJson('/Nosology/GetNames', { data: item })
    }
};
